(() => {
  const carouselSelector = '[data-k18-product-carousel]';

  const getScrollAmount = (track) => {
    const slide = track.querySelector('.k18pc__slide');
    if (!slide) return track.clientWidth * 0.8;

    const styles = window.getComputedStyle(track.querySelector('.k18pc__track'));
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  };

  const setControlState = (carousel) => {
    const viewport = carousel.querySelector('[data-k18-carousel-track]');
    const previous = carousel.querySelector('[data-k18-carousel-previous]');
    const next = carousel.querySelector('[data-k18-carousel-next]');
    if (!viewport) return;

    const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
    const hasOverflow = maxScroll > 2;

    if (previous) previous.disabled = !hasOverflow || viewport.scrollLeft <= 2;
    if (next) next.disabled = !hasOverflow || viewport.scrollLeft >= maxScroll - 2;
  };

  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.k18CarouselReady === 'true') return;

    const viewport = carousel.querySelector('[data-k18-carousel-track]');
    const previous = carousel.querySelector('[data-k18-carousel-previous]');
    const next = carousel.querySelector('[data-k18-carousel-next]');
    if (!viewport) return;

    carousel.dataset.k18CarouselReady = 'true';

    const scroll = (direction) => {
      viewport.scrollBy({
        left: direction * getScrollAmount(viewport),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };

    previous?.addEventListener('click', () => scroll(-1));
    next?.addEventListener('click', () => scroll(1));
    viewport.addEventListener('scroll', () => setControlState(carousel), { passive: true });
    window.addEventListener('resize', () => setControlState(carousel), { passive: true });
    requestAnimationFrame(() => setControlState(carousel));
  };

  const initAll = (root = document) => {
    if (root.matches?.(carouselSelector)) initCarousel(root);
    root.querySelectorAll?.(carouselSelector).forEach(initCarousel);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:reorder', () => initAll());
  document.addEventListener('shopify:section:select', (event) => initAll(event.target));
})();
